<div *ngIf="false" class="container">
  <div class="row head">
    <div class="col-12">
      <span class="title" i18n="parameters-options|@@manageOptions">Gestion des options</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12 report-form">
      <span  class="column-title" i18n="parameters-options|@@damage">Dommages</span>
      <div class="table-option-toggle">
        <div class="conatainer">
          <div class="row m-0 center">
            <div class="col-5 col-md-3">
              <span class="column-title" i18n="app-parameters-options|@@option">Dommage</span>
            </div>
            <div class="d-none d-md-block col-4">
              <span class="column-title" i18n="app-parameters-options|@@libelle">Libellé</span>
            </div>
            <div class="col-7 col-md-3">
              <span class="column-title" i18n="app-parameters-options|@@activite">Activé</span>
            </div>
            <div class="d-none d-md-block  col-2">
              <span class="column-title" i18n="app-parameters-options|@@actions">Actions</span>
            </div>
          </div>
          <div class="row m-0">
            <div class="col-5 col-md-3 center">
              <span i18n="app-parameters-options|@@scratch">Rayure</span>
            </div>
            <div class="d-none d-md-block col-4 center">
              Rayure <svg width="13px" height="13px" viewBox="0 0 13 13" version="1.1"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>pen-01</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.5">
                  <g id="UI-Rapport" transform="translate(-732.000000, -206.000000)" fill="#162C4B" fill-rule="nonzero">
                    <g id="Header-Small" transform="translate(165.000000, 153.000000)">
                      <g id="Group-Copy-3" transform="translate(452.000000, 24.000000)">
                        <g id="pen-01" transform="translate(115.000000, 29.000000)">
                          <path
                            d="M6.48,3 L0.24,9.24 C0.08,9.4 0,9.56 0,9.8 L0,12.2 C0,12.68 0.32,13 0.8,13 L3.2,13 C3.44,13 3.6,12.92 3.76,12.76 L10,6.52 L6.48,3 Z"
                            id="Path"></path>
                          <path
                            d="M12.7692308,2.53846154 L10.4615385,0.230769231 C10.1538462,-0.0769230769 9.69230769,-0.0769230769 9.38461538,0.230769231 L8,1.61538462 L11.3846154,5 L12.7692308,3.61538462 C13.0769231,3.30769231 13.0769231,2.84615385 12.7692308,2.53846154 Z"
                            id="Path"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div class="col-7 col-md-3">
              <div class="parameters-toggle ">
          <app-generic-toggle [value]="" ></app-generic-toggle>
              </div>
            </div>
            <div class="d-none d-md-block  col-2 center">
              <svg width="4px" height="16px" viewBox="0 0 4 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>menu-dots</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Rapport" transform="translate(-1231.000000, -191.000000)" fill="#162C4B"
                    fill-rule="nonzero">
                    <g id="Header-Small" transform="translate(165.000000, 153.000000)">
                      <g id="CTA" transform="translate(1050.000000, 23.000000)">
                        <g id="menu-dots"
                          transform="translate(18.000000, 23.000000) rotate(90.000000) translate(-18.000000, -23.000000) translate(10.000000, 21.000000)">
                          <circle id="Oval" cx="8" cy="2" r="2"></circle>
                          <circle id="Oval" cx="2" cy="2" r="2"></circle>
                          <circle id="Oval" cx="14" cy="2" r="2"></circle>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>

          <div class="row m-0">
            <div class="col-5 col-md-3 center">
              <span  i18n="parameters-options|@@bump">Bosse</span>
            </div>
            <div class="d-none d-md-block col-4 center">
              Bosse <svg width="13px" height="13px" viewBox="0 0 13 13" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>pen-01</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.5">
                  <g id="UI-Rapport" transform="translate(-732.000000, -206.000000)" fill="#162C4B" fill-rule="nonzero">
                    <g id="Header-Small" transform="translate(165.000000, 153.000000)">
                      <g id="Group-Copy-3" transform="translate(452.000000, 24.000000)">
                        <g id="pen-01" transform="translate(115.000000, 29.000000)">
                          <path
                            d="M6.48,3 L0.24,9.24 C0.08,9.4 0,9.56 0,9.8 L0,12.2 C0,12.68 0.32,13 0.8,13 L3.2,13 C3.44,13 3.6,12.92 3.76,12.76 L10,6.52 L6.48,3 Z"
                            id="Path"></path>
                          <path
                            d="M12.7692308,2.53846154 L10.4615385,0.230769231 C10.1538462,-0.0769230769 9.69230769,-0.0769230769 9.38461538,0.230769231 L8,1.61538462 L11.3846154,5 L12.7692308,3.61538462 C13.0769231,3.30769231 13.0769231,2.84615385 12.7692308,2.53846154 Z"
                            id="Path"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div class="col-7 col-md-3">
              <div class="parameters-toggle ">
          <app-generic-toggle [value]="" ></app-generic-toggle>
              </div>
            </div>
            <div class="d-none d-md-block  col-2 center">
              <svg width="4px" height="16px" viewBox="0 0 4 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>menu-dots</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Rapport" transform="translate(-1231.000000, -191.000000)" fill="#162C4B"
                    fill-rule="nonzero">
                    <g id="Header-Small" transform="translate(165.000000, 153.000000)">
                      <g id="CTA" transform="translate(1050.000000, 23.000000)">
                        <g id="menu-dots"
                          transform="translate(18.000000, 23.000000) rotate(90.000000) translate(-18.000000, -23.000000) translate(10.000000, 21.000000)">
                          <circle id="Oval" cx="8" cy="2" r="2"></circle>
                          <circle id="Oval" cx="2" cy="2" r="2"></circle>
                          <circle id="Oval" cx="14" cy="2" r="2"></circle>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
          <div class="row m-0">
            <div class="col-5 col-md-3 center">
              <span  i18n="parameters-options|@@rub">Frottement</span>
            </div>
            <div class="d-none d-md-block col-4 center">
              Frottement <svg width="13px" height="13px" viewBox="0 0 13 13" version="1.1"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>pen-01</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.5">
                  <g id="UI-Rapport" transform="translate(-732.000000, -206.000000)" fill="#162C4B" fill-rule="nonzero">
                    <g id="Header-Small" transform="translate(165.000000, 153.000000)">
                      <g id="Group-Copy-3" transform="translate(452.000000, 24.000000)">
                        <g id="pen-01" transform="translate(115.000000, 29.000000)">
                          <path
                            d="M6.48,3 L0.24,9.24 C0.08,9.4 0,9.56 0,9.8 L0,12.2 C0,12.68 0.32,13 0.8,13 L3.2,13 C3.44,13 3.6,12.92 3.76,12.76 L10,6.52 L6.48,3 Z"
                            id="Path"></path>
                          <path
                            d="M12.7692308,2.53846154 L10.4615385,0.230769231 C10.1538462,-0.0769230769 9.69230769,-0.0769230769 9.38461538,0.230769231 L8,1.61538462 L11.3846154,5 L12.7692308,3.61538462 C13.0769231,3.30769231 13.0769231,2.84615385 12.7692308,2.53846154 Z"
                            id="Path"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div class="col-7 col-md-3">
              <div class="parameters-toggle ">
                <app-generic-toggle [value]="" ></app-generic-toggle>
              </div>
            </div>
            <div class="d-none d-md-block col-2 center">
              <svg width="4px" height="16px" viewBox="0 0 4 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>menu-dots</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Rapport" transform="translate(-1231.000000, -191.000000)" fill="#162C4B"
                    fill-rule="nonzero">
                    <g id="Header-Small" transform="translate(165.000000, 153.000000)">
                      <g id="CTA" transform="translate(1050.000000, 23.000000)">
                        <g id="menu-dots"
                          transform="translate(18.000000, 23.000000) rotate(90.000000) translate(-18.000000, -23.000000) translate(10.000000, 21.000000)">
                          <circle id="Oval" cx="8" cy="2" r="2"></circle>
                          <circle id="Oval" cx="2" cy="2" r="2"></circle>
                          <circle id="Oval" cx="14" cy="2" r="2"></circle>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 ">
      <span class="column-title" i18n="parameters-options|@@checklis">Checklist</span>
      <div class="table-option-toggle">
        <div class="conatainer">
          <div class="row m-0 center">
            <div class="col-5 col-md-3">
              <span class="column-title" i18n="app-parameters-options|@@option">Dommage</span>
            </div>
            <div class="d-none d-md-block col-4">
              <span class="column-title" i18n="app-parameters-options|@@libelle">Libellé</span>
            </div>
            <div class="col-7 col-md-3">
              <span class="column-title" i18n="app-parameters-options|@@activite">Activé</span>
            </div>
            <div class="d-none d-md-block  col-2">
              <span class="column-title" i18n="app-parameters-options|@@actions">Actions</span>
            </div>
          </div>
          <div class="row m-0">
            <div class="col-5 col-md-3 center">
              <span i18n="parameters-options|@@scratch">Rayure</span>
            </div>
            <div class="d-none d-md-block col-4 center" i18n="parameters-options|@@scratch">
              Rayure
            </div>
            <div class="col-7 col-md-3">
              <div class="parameters-toggle ">
          <app-generic-toggle [value]="" ></app-generic-toggle>
              </div>
            </div>
            <div class="d-none d-md-block  col-2 center">
              <svg width="4px" height="16px" viewBox="0 0 4 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>menu-dots</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Rapport" transform="translate(-1231.000000, -191.000000)" fill="#162C4B"
                    fill-rule="nonzero">
                    <g id="Header-Small" transform="translate(165.000000, 153.000000)">
                      <g id="CTA" transform="translate(1050.000000, 23.000000)">
                        <g id="menu-dots"
                          transform="translate(18.000000, 23.000000) rotate(90.000000) translate(-18.000000, -23.000000) translate(10.000000, 21.000000)">
                          <circle id="Oval" cx="8" cy="2" r="2"></circle>
                          <circle id="Oval" cx="2" cy="2" r="2"></circle>
                          <circle id="Oval" cx="14" cy="2" r="2"></circle>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>

          <div class="row m-0">
            <div class="col-5 col-md-3 center">
              <span  i18n="parameters-options|@@bump">Bosse</span>
            </div>
            <div class="d-none d-md-block col-4 center" i18n="parameters-options|@@bump">
              Bosse
            </div>
            <div class="col-7 col-md-3">
              <div class="parameters-toggle ">
          <app-generic-toggle [value]="" ></app-generic-toggle>
              </div>
            </div>
            <div class="d-none d-md-block  col-2 center">
              <svg width="4px" height="16px" viewBox="0 0 4 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>menu-dots</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Rapport" transform="translate(-1231.000000, -191.000000)" fill="#162C4B"
                    fill-rule="nonzero">
                    <g id="Header-Small" transform="translate(165.000000, 153.000000)">
                      <g id="CTA" transform="translate(1050.000000, 23.000000)">
                        <g id="menu-dots"
                          transform="translate(18.000000, 23.000000) rotate(90.000000) translate(-18.000000, -23.000000) translate(10.000000, 21.000000)">
                          <circle id="Oval" cx="8" cy="2" r="2"></circle>
                          <circle id="Oval" cx="2" cy="2" r="2"></circle>
                          <circle id="Oval" cx="14" cy="2" r="2"></circle>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
          <div class="row m-0">
            <div class="col-5 col-md-3 center">
              <span i18n="parameters-options|@@rub">Frottement</span>
            </div>
            <div i18n="parameters-options|@@rub" class="d-none d-md-block col-4 center">
              Frottement
            </div>
            <div class="col-7 col-md-3">
              <div class="parameters-toggle ">
          <app-generic-toggle [value]="" ></app-generic-toggle>
              </div>
            </div>
            <div class="d-none d-md-block col-2 center">
              <svg width="4px" height="16px" viewBox="0 0 4 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>menu-dots</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Rapport" transform="translate(-1231.000000, -191.000000)" fill="#162C4B"
                    fill-rule="nonzero">
                    <g id="Header-Small" transform="translate(165.000000, 153.000000)">
                      <g id="CTA" transform="translate(1050.000000, 23.000000)">
                        <g id="menu-dots"
                          transform="translate(18.000000, 23.000000) rotate(90.000000) translate(-18.000000, -23.000000) translate(10.000000, 21.000000)">
                          <circle id="Oval" cx="8" cy="2" r="2"></circle>
                          <circle id="Oval" cx="2" cy="2" r="2"></circle>
                          <circle id="Oval" cx="14" cy="2" r="2"></circle>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/parameters-options/parameters-options.component.html